import { convertFileToBase64 } from "../../../components/utils/utils";
export const handleFileChange = async (
  fileList: any[],
  setFieldsValue: (values: any) => void,
  fieldName: string
) => {
  const validFilesData = await Promise.all(
    fileList.map(async (fileWrapper: any) => {
      const file = fileWrapper.originFileObj;

      if (file) {
        try {
          const base64 = await convertFileToBase64(file);
          return {
            filename: file.name,
            data: base64,
          };
        } catch (error) {
          console.error("Error converting file to Base64:", error);
          return null;
        }
      }
      return null;
    })
  );

  const filteredData = validFilesData.filter(
    (file) => file?.data && file?.filename
  );

  setFieldsValue({
    [fieldName]: filteredData,
  });
};
